import Vue from "vue";
import Router from "vue-router";
import Timesheet from "./views/Timesheet.vue";
import About from "./views/About.vue";

Vue.use(Router);

export default new Router({
  mode: "history",

  routes: [
    {
      path: "/",
      name: "timesheet",
      component: Timesheet
    },
    {
      path: "/about",
      name: "about",
      component: About
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router.js